import React, { useState } from 'react';
import './SiteSimulator.css';

const siteNames = [
  'Damana',
  'DAV School',
  'Janata Maidan',
  'Dump Yard',
  'Gajapati Nagar',
  'Prasanti Vihar',
  'Jagannath Temple'
];

function getRandomValue(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function SiteSimulator() {
  const [selectedSite, setSelectedSite] = useState('');
  const [data, setData] = useState(null);

  const handleSelect = (e) => {
    const site = e.target.value;
    setSelectedSite(site);
    setData({
      tds: getRandomValue(140, 170),
      ph: Math.random() > 0.5 ? 7 : 7.5,
      temp1: getRandomValue(30, 35),
      temp2: getRandomValue(30, 35)
    });
  };

  return (
    <div className="site-container">

      <h2>Select a Site</h2>
      <select className="site-select" value={selectedSite} onChange={handleSelect}>
        <option value="">-- Select Site --</option>
        {siteNames.map(site => (
          <option key={site} value={site}>{site}</option>
        ))}
      </select>

      {data && (
        <div className="site-card">
          <div><strong>Site</strong><br />{selectedSite}</div>
          <div><strong>TDS</strong><br />{data.tds} ppm</div>
          <div><strong>pH</strong><br />{data.ph}</div>
          <div><strong>Temp 1</strong><br />{data.temp1} °C</div>
          <div><strong>Temp 2</strong><br />{data.temp2} °C</div>
        </div>
      )}
    </div>
  );
}

export default SiteSimulator;
